import React, { useEffect, useState } from "react";
import CustomIcons from "../../../../components/icons/kIcons.component";
import { download_student_proposal_file } from "../../user.api";
import CustomTable from "../../../../components/table/table";

export default function TechPropTile(props) {
  const [data, setData] = useState(props.data);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleDownloadProposal = () => {
    let path = `${result}${data.file_upload_proposal}`;
    window.open(path, "_blank");
  };
  const handleDownload = (e) => {
    let path = `${result}${data.file_upload_proposal}`;
    window.open(path, "_blank");
  };
  const handleDownloadResume = (e) => {
    let path = `${result}${data.file_upload_proposal}`;
    window.open(path, "_blank");
  };
  const handleEDownload = (e) => {
    let path = `${result}${e}`;
    window.open(path, "_blank");
  };

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const handleDownloadDocument = async (id) => {
    if (!id) {
      console.error("User ID is missing for download");
      return;
    }

    try {
      const response = await download_student_proposal_file(id);

      // Extract the file URL from the response
      const fileUrl = response?.url;

      if (!fileUrl) {
        console.error("Invalid response: No URL found in API response.");
        return;
      }

      // Open the file in a new tab
      const newTab = window.open(fileUrl, "_blank");

      // Handle cases where the browser blocks pop-ups
      if (!newTab) {
        alert("Popup blocked! Please allow popups for this site.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const handleViewDetail = (data) => {
    let path = "/student-proposal-detail/" + data.id;
    props.history.push(path);
  };
  return (
    <div className="view-container">

      <div className="data">
        <div className="row">
          <div className="col-3">Proposal Title</div>
          <div className="col-1">:</div>
          <div className="col-7">{data.project_title}</div>
        </div>

        <div className="row">
          <div className="col-3">Project Guides</div>
          <div className="col-1">:</div>
          <div className="col-7">
            <p>
              <div className="d-flex col-12">
                <div className="col-2">
                  {" "}
                  <b>Guide 1</b>
                </div>
                <div className="col-1">:</div>
                <div className="col-7">
                  <div>Name : {data.project_guide1}</div>
                  <div>Phone : {data.project_guide1_phone}</div>
                  <div>Email : {data.project_guide1_email}</div>
                </div>
              </div>
            </p>
            <p>
              <div className="d-flex col-12">
                <div className="col-2">
                  {" "}
                  <b>Guide 2</b>
                </div>
                <div className="col-1">:</div>
                <div className="col-7">
                  <div>Name : {data.project_guide2}</div>
                  <div>Phone : {data.project_guide2_phone}</div>
                  <div>Email : {data.project_guide2_email}</div>
                </div>
              </div>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-3">Students Details</div>
          <div className="col-1">:</div>
          <div className="col-7 mt-00">
            <CustomTable
              {...props}
              columns={[
                { title: "Student Name", field: "student_name" },
                { title: "Semester", field: "semester" },
                { title: "Branch", field: "branch" },
                { title: "Previous year Mark", field: "mark" },
                { title: "Photo", field: "photo", type: "image" },
                { title: "Resume", field: "resume", type: "download" },
                { title: "Mark List", field: "marklist", type: "download" },
              ]}
              data={data.studentsadded ?? []}
              handleDownload={handleDownload}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3">Short Details of Proposal</div>
          <div className="col-1">:</div>
          <div className="col-7">{data.short_proposal_details}</div>
        </div>
        <div className="row">
          <div className="col-3">Uploaded Proposal</div>
          <div className="col-1">:</div>
          <div className="col-7">
            <button
              type="button"
              onClick={(e) => handleDownloadProposal(data)}
              className="btn btn-reject btn-dark btn-sm"
            >
              Download Proposal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
